/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Trip } from '../models/Trip';
import type { Vehicle } from '../models/Vehicle';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class TripsService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * @returns any Trips
   * @throws ApiError
   */
  public searchTrips({
    policyId,
    after,
    startedAtAfter,
    startedAtBefore,
    term,
    speedingBandCategory,
    sortKey,
    sortOrder,
    limit,
    dbName,
    safetyScoreFrom,
    safetyScoreTo,
    minTripDurationMinutes,
  }: {
    policyId: string,
    after?: string,
    /**
     * ISO 8601 date-time to query for trips started after this date-time.
     */
    startedAtAfter?: string,
    /**
     * ISO 8601 date-time to query for trips started before this date-time. Must be used in conjunction with startedAtAfter
     */
    startedAtBefore?: string,
    term?: string,
    speedingBandCategory?: 'critical' | 'major' | 'minor',
    sortKey?: 'vrn' | 'riskScore' | 'startedAt' | 'finishedAt' | 'critical' | 'major' | 'minor' | 'distanceKm' | 'highSpeedingDistanceKm' | 'urbanHighSpeedingDistanceKm' | 'nonUrbanHighSpeedingDistanceKm',
    sortOrder?: 'ASC' | 'DESC',
    limit?: number,
    dbName?: string,
    safetyScoreFrom?: number,
    safetyScoreTo?: number,
    minTripDurationMinutes?: number,
  }): CancelablePromise<{
    total: number;
    next: string | null;
    items: Array<Trip>;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/motor/insights/{policyId}/trips',
      path: {
        'policyId': policyId,
      },
      query: {
        'after': after,
        'startedAtAfter': startedAtAfter,
        'startedAtBefore': startedAtBefore,
        'term': term,
        'speedingBandCategory': speedingBandCategory,
        'sortKey': sortKey,
        'sortOrder': sortOrder,
        'limit': limit,
        'dbName': dbName,
        'safetyScoreFrom': safetyScoreFrom,
        'safetyScoreTo': safetyScoreTo,
        'minTripDurationMinutes': minTripDurationMinutes,
      },
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        404: `Not Found Error`,
      },
    });
  }

  /**
   * @returns any Trip
   * @throws ApiError
   */
  public findTrip({
    policyId,
    tripId,
    dbName,
  }: {
    policyId: string,
    tripId: string,
    dbName?: string,
  }): CancelablePromise<(Trip & {
    geojsonUrl: string;
    hereGeojsonUrl?: string;
    geoJsonStringContent?: string;
  })> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/motor/insights/{policyId}/trips/{tripId}',
      path: {
        'policyId': policyId,
        'tripId': tripId,
      },
      query: {
        'dbName': dbName,
      },
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        404: `Not Found Error`,
      },
    });
  }

  /**
   * @returns any Vehicles
   * @throws ApiError
   */
  public searchVehicles({
    policyId,
    after,
    term,
    sortKey,
    sortOrder,
    limit = 50,
    minimumDistanceDriven,
    dbName,
  }: {
    policyId: string,
    after?: string,
    term?: string,
    sortKey?: 'vrn' | 'currentPeriod.riskScore' | 'total.distanceKm' | 'currentPeriod.distanceKm' | 'total.riskScore' | 'total.driverRanking' | 'currentPeriod.driverRanking',
    sortOrder?: 'ASC' | 'DESC',
    limit?: number,
    minimumDistanceDriven?: number,
    dbName?: string,
  }): CancelablePromise<{
    total: number;
    next: string | null;
    items: Array<Vehicle>;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/motor/insights/{policyId}/vehicles',
      path: {
        'policyId': policyId,
      },
      query: {
        'after': after,
        'term': term,
        'sortKey': sortKey,
        'sortOrder': sortOrder,
        'limit': limit,
        'minimumDistanceDriven': minimumDistanceDriven,
        'dbName': dbName,
      },
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        404: `Not Found Error`,
      },
    });
  }

  /**
   * @returns Vehicle Vehicle
   * @throws ApiError
   */
  public getInsightsVehicle({
    policyId,
    vrn,
    dbName,
  }: {
    policyId: string,
    vrn: string,
    dbName?: string,
  }): CancelablePromise<Vehicle> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/motor/insights/{policyId}/vehicles/{vrn}',
      path: {
        'policyId': policyId,
        'vrn': vrn,
      },
      query: {
        'dbName': dbName,
      },
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        404: `Not Found Error`,
      },
    });
  }

  /**
   * @returns any Trips
   * @throws ApiError
   */
  public vehicleTrips({
    policyId,
    vrn,
    after,
    startedAtAfter,
    startedAtBefore,
    term,
    speedingBandCategory,
    sortKey,
    sortOrder,
    limit,
    dbName,
    safetyScoreFrom,
    safetyScoreTo,
    minTripDurationMinutes,
  }: {
    policyId: string,
    vrn: string,
    after?: string,
    /**
     * ISO 8601 date-time to query for trips started after this date-time.
     */
    startedAtAfter?: string,
    /**
     * ISO 8601 date-time to query for trips started before this date-time. Must be used in conjunction with startedAtAfter
     */
    startedAtBefore?: string,
    term?: string,
    speedingBandCategory?: 'critical' | 'major' | 'minor',
    sortKey?: 'vrn' | 'riskScore' | 'startedAt' | 'finishedAt' | 'critical' | 'major' | 'minor' | 'distanceKm' | 'highSpeedingDistanceKm' | 'urbanHighSpeedingDistanceKm' | 'nonUrbanHighSpeedingDistanceKm',
    sortOrder?: 'ASC' | 'DESC',
    limit?: number,
    dbName?: string,
    safetyScoreFrom?: number,
    safetyScoreTo?: number,
    minTripDurationMinutes?: number,
  }): CancelablePromise<{
    total: number;
    next: string | null;
    items: Array<Trip>;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/motor/insights/{policyId}/vehicles/{vrn}/trips',
      path: {
        'policyId': policyId,
        'vrn': vrn,
      },
      query: {
        'after': after,
        'startedAtAfter': startedAtAfter,
        'startedAtBefore': startedAtBefore,
        'term': term,
        'speedingBandCategory': speedingBandCategory,
        'sortKey': sortKey,
        'sortOrder': sortOrder,
        'limit': limit,
        'dbName': dbName,
        'safetyScoreFrom': safetyScoreFrom,
        'safetyScoreTo': safetyScoreTo,
        'minTripDurationMinutes': minTripDurationMinutes,
      },
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        404: `Not Found Error`,
      },
    });
  }

}
